import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Routes from './routes';
import LoadingScreen, { ProgressBarStyle } from 'src/minimals/LoadingScreen';
import Settings from 'src/minimals/settings';
import ThemePrimaryColor from 'src/minimals/ThemePrimaryColor';
import GlobalStyles from 'src/theme/globalStyles';
import { ConfirmProvider } from 'material-ui-confirm';
import { uiSelectors } from 'src/selectors';
import init from 'src/redux/thunks/init';
import ThemeConfig from './theme';
import { LicenseInfo } from '@mui/x-license-pro';
import ChatContextProvider from './common/Chat/context/ChatContext';

// if (import.meta.hot) {
//   import.meta.hot.accept();
// }

LicenseInfo.setLicenseKey('YOUR_LICENSE_KEY');
const App = () => {
  const isLoading = useSelector(uiSelectors.getLoadingState());
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(init());
  }, [dispatch]);

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <GlobalStyles />
        <ProgressBarStyle />
        <ConfirmProvider>
          {!isLoading ? <Routes /> : <LoadingScreen />}
        </ConfirmProvider>
        <Settings />
      </ThemePrimaryColor>
    </ThemeConfig>
  );
};

export default App;
